import { useEffect } from 'react';
import { useParams } from 'react-router';
import './ChatWindow.css';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import TypingIndicator from './TypingIndicator';
import { useChat } from '../hooks/useChat';
import { useMobileViewportFix } from '../hooks/useMobileViewportFix';
import { CHAT_ESCAPE_MESSAGE } from '../content/site';

function ChatWindow() {
  // Get the chat ID from the URL
  const { id } = useParams<{ id?: string }>();
  
  // Use our custom hooks
  const { messages, sendMessage, isLoading, error } = useChat({ 
    chatId: id,
    maxMessages: 10
  });

  // Apply mobile viewport fixes using the custom hook
  useMobileViewportFix();

  // Embedded in the site's chat widget: key presses inside this iframe never
  // reach the parent page, so forward Escape to let the widget minimise.
  useEffect(() => {
    if (window.parent === window) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        window.parent.postMessage({ type: CHAT_ESCAPE_MESSAGE }, window.location.origin);
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <div className="chat-container">
      {error && (
        <div className="error-message" role="alert" aria-live="assertive">
          {error}
        </div>
      )}
      
      <MessageList messages={messages} />
      
      {isLoading && <TypingIndicator />}
      
      <MessageInput 
        onSendMessage={sendMessage}
        disabled={isLoading} 
      />
    </div>
  );
}

export default ChatWindow;
